import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../environment/environment';

// Define interfaces locally to avoid circular dependencies
export interface ProviderOnboardingRequest {
  firstName: string;
  lastName: string;
  groupNpi: string;
  individualNpi: string;
  emailAddress: string;
  phoneNumber: string;
  clinicName: string;
  address: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
}

export interface ProviderOnboardingResponse {
  success: boolean;
  provider_id: number;
  clinic_id: number;
  clinic_location_id: number;
  cognito_username: string;
  message: string;
  email_sent: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ProviderApplicationService {
  constructor(private http: HttpClient) {}
  private api = environment.apiBase
  // Replace with your actual API endpoint
  private readonly apiUrl = `${this.api}/provider/onboarding`;

  /**
   * Submit provider onboarding application
   * @param applicationData - The provider application form data
   * @returns Observable of the API response
   */
  public submitApplication(applicationData: ProviderOnboardingRequest): Observable<ProviderOnboardingResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    });
    
    return this.http.post<ProviderOnboardingResponse>(this.apiUrl, applicationData, { headers }).pipe(
      catchError((error: HttpErrorResponse) => throwError(() => error.error))
    )
  }

}
